// @theme component
import { send } from 'server';
import { IFidoAuthentificatorData } from './types';

export const getFidoAuthenticators = () => send({
    ID: 35925,
    responses: [35926, 35927],
    description: 'Get Fido Authenticators Request'
});

export const setFidoAuthenticators = (updatedAuthenticators: IFidoAuthentificatorData[]) => send({
    ID: 35928,
    responses: [35929, 35930],
    fidoAuthenticators: updatedAuthenticators,
    description: 'Set Fido Authenticators Request'
});
